import { Heading, Modal, Paragraph } from '@zillow/constellation-10';
import { FacebookPostPreview } from './FacebookPostPreview';
import { InstagramPostPreview } from './InstagramPostPreview';
import { InstagramStory } from './InstagramStory';

export const MetaAdsPreview = ({
  previewImages,
  address,
  title,
  description,
  trigger,
}: {
  previewImages: Array<string>;
  address: string;
  title: string;
  description: string;
  trigger?: React.ReactNode;
}) => (
  <Modal
    header={
      <Heading level={6} css={{ textAlign: 'center' }}>
        Ad preview
      </Heading>
    }
    size={{ base: 'fullScreen', lg: 'md' }}
    body={
      <>
        <Paragraph textStyle="body-bold" css={{ marginBottom: '100' }}>
          Facebook ad
        </Paragraph>
        <FacebookPostPreview previewImages={previewImages} address={address} title={title} description={description} />
        <Paragraph textStyle="body-bold" css={{ marginBottom: '100', marginTop: '400' }}>
          Instagram post
        </Paragraph>
        <InstagramPostPreview imageUrls={previewImages} description={description} />
        <Paragraph textStyle="body-bold" css={{ marginBottom: '100', marginTop: '400' }}>
          Instagram story preview
        </Paragraph>
        <InstagramStory imageUrls={previewImages} description={description} title={title} />
      </>
    }
    trigger={trigger}
  />
);
